import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {
  FireAlarmSystemComponentDto,
  FireAlarmSystemDesign
} from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-fire-alarm-system',
  templateUrl: './fire-alarm-system.component.html',
  styleUrls: ['./fire-alarm-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FireAlarmSystemComponent {
  @Input() data: FireAlarmSystemDesign;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  onDataChange(): void {
    this.dataChange.emit();
  }

  onComponentsChange(components: FireAlarmSystemComponentDto[]): void {
    this.data.fireAlarmSystemComponents.components = components;
    this.dataChange.emit();
  }
}
